const now = new Date()

const communityTopic1 = {
  id: '1',
  user: {
    id: '111',
    avatar: 'https://content-software.com/assets/Team/konrad-hepp.jpg',
    name: 'Konrad Hepp',
  },
  title: 'Lithium, was gibt es für sinnvolle Investitionsmöglichkeiten',
  //lastModified: now,
  category: 'Investieren in E-Mobilität',
  replies: 20,
  finScore: 90,
  portfolio: {
    performance: 10.45,
    name: 'Der Renditegaul'
  }
}

const communityTopic2 = {
  id: '2',
  user: {
    id: '222',
    avatar: 'https://content-software.com/assets/Team/torsten-greiff.jpg',
    name: 'Torsten Greiff',
    level: 'finEXP'
  },
  title: 'Neuer Megatrend Wasserstoff, Hype oder echte Chance',
  //lastModified: new Date(now.getTime()).setHours(now.getHours() - 1),
  category: 'Langfristige Megatrendes',
  replies: 16,
  finScore: 98,
  portfolio: {
    performance: 9.88,
    name: 'Warren Buffett meets Elon Musk **'
  }
}

const communityTopic3 = {
  id: '3',
  user: {
    id: '333',
    avatar: 'https://content-software.com/assets/Team/marcus-klein.jpg',
    name: 'Marcus Klein',
    level: 'finEXP'
  },
  title: 'Environment, Social, Governance (ESG) bringt uns das weiter?',
  //lastModified: new Date(now.getTime()).setHours(now.getHours() - 2),
  category: 'Nachhaltig Investieren',
  replies: 62,
  finScore: 89,
  portfolio: {
    performance: 10.79,
    name: 'Smart & Rich'
  }
}

const communityTopic4 = {
  id: '4',
  user: {
    id: '444',
    avatar: 'https://content-software.com/assets/Team/thorsten-meyer.jpg',
    name: 'Thorsten Meyer',
    level: 'Lorem Egg'
  },
  title: 'Die besten COVID-19 Vaccine Aktien',
  //lastModified: new Date(now.getTime()).setHours(now.getHours() - 3),
  category: 'Corona Profiteure',
  replies: 71,
  finScore: 92,
  portfolio: {
    performance: 12.33,
    name: 'Golddigger\'s Portfolio'
  }
}


export const communityTopics = [
  communityTopic1, communityTopic2, communityTopic3, communityTopic4
]

export const survey = {
  answers: ['Nein', 'Neutral', 'Ja'],
  neutralPosition: 1,
  question: 'Werden Sie Fincraft Pro User?',
  results: 760
}

export const latestForumsPosts = [
  {
    user: {
      avatar: 'https://content-software.com/assets/Team/maximilan-franke.jpg',
      fullname: 'Maximilian Franke'
    },
    post: {
      lastModified: 'vor 1h',
      category: 'Investment-Strategien',
      title: 'Lorem ipsum dolor sit amet',
      commentCount: 20,
      readCount: 125
    }
  },
  {
    user: {
      avatar: 'https://content-software.com/assets/Team/barbara-moeller.jpg',
      fullname: 'Erika Musterfrau'
    },
    post: {
      lastModified: 'vor 2h',
      category: 'Investment-Strategien',
      title: 'Consetetur sadipscing elitr',
      commentCount: 25,
      readCount: 100
    }
  },
  {
    user: {
      avatar: 'https://content-software.com/assets/Team/peter-adrian.jpg',
      fullname: 'Hello World'
    },
    post: {
      lastModified: 'vor 3h',
      category: 'Investment-Strategien',
      title: 'Sed diam nonumy eirmod',
      commentCount: 77,
      readCount: 312
    }
  },
  {
    user: {
      avatar: 'https://content-software.com/assets/Team/fokko-bucys.jpg',
      fullname: 'Martin Mustermann'
    },
    post: {
      lastModified: 'vor 4h',
      category: 'Investment-Strategien',
      title: 'Lorem ipsum dolor sit amet',
      commentCount: 20,
      readCount: 125
    }
  },
  {
    user: {
      avatar: 'https://content-software.com/assets/Team/marcus-klein.jpg',
      fullname: 'Erika Musterfrau'
    },
    post: {
      lastModified: 'vor 5h',
      category: 'Investment-Strategien',
      title: 'Consetetur sadipscing elitr',
      commentCount: 25,
      readCount: 100
    }
  },
  {
    user: {
      avatar: 'https://content-software.com/assets/Team/torsten-greiff.jpg',
      fullname: 'Hello World'
    },
    post: {
      lastModified: 'vor 6h',
      category: 'Investment-Strategien',
      title: 'Sed diam nonumy eirmod',
      commentCount: 77,
      readCount: 312
    }
  },
  {
    user: {
      avatar: 'https://content-software.com/assets/Team/torsten-greiff.jpg',
      fullname: 'Max Mustermann'
    },
    post: {
      lastModified: 'vor 7h',
      category: 'Investment-Strategien',
      title: 'Lorem ipsum dolor sit amet',
      commentCount: 20,
      readCount: 125
    }
  },
  {
    user: {
      avatar: 'https://content-software.com/assets/Team/thorsten-meyer.jpg',
      fullname: 'Erika Musterfrau'
    },
    post: {
      lastModified: 'vor 8h',
      category: 'Investment-Strategien',
      title: 'Consetetur sadipscing elitr',
      commentCount: 25,
      readCount: 100
    }
  },
  {
    user: {
      avatar: 'https://content-software.com/assets/Team/torsten-greiff.jpg',
      fullname: 'Hello World'
    },
    post: {
      lastModified: 'vor 9h',
      category: 'Investment-Strategien',
      title: 'Sed diam nonumy eirmod',
      commentCount: 77,
      readCount: 312
    }
  },
  {
    user: {
      avatar: 'https://content-software.com/assets/Team/maximilan-franke.jpg',
      fullname: 'Martin Mustermann'
    },
    post: {
      lastModified: 'vor 10h',
      category: 'Investment-Strategien',
      title: 'Lorem ipsum dolor sit amet',
      commentCount: 20,
      readCount: 125
    }
  },
  {
    user: {
      avatar: 'https://content-software.com/assets/Team/konrad-hepp.jpg',
      fullname: 'Erika Musterfrau'
    },
    post: {
      lastModified: 'vor 11h',
      category: 'Investment-Strategien',
      title: 'Consetetur sadipscing elitr',
      commentCount: 25,
      readCount: 100
    }
  },
  {
    user: {
      avatar: 'https://content-software.com/assets/Team/torsten-greiff.jpg',
      fullname: 'Erika Musterfrau'
    },
    post: {
      lastModified: 'vor 12h',
      category: 'Investment-Strategien',
      title: 'Consetetur sadipscing elitr',
      commentCount: 25,
      readCount: 100
    }
  }
]

export const sharesRanking = [
  {
    nr: 1,
    title: 'Dogs of the Dow',
    userCount: 200
  },
  {
    nr: 2,
    title: 'Rodney Smith',
    userCount: 150
  },
  {
    nr: 3,
    title: 'Alan River',
    userCount: 185
  }
]

export const etfRanking = [
  {
    nr: 1,
    title: 'DAX',
    userCount: 195
  },
  {
    nr: 2,
    title: 'MSCI World Index',
    userCount: 125
  },
  {
    nr: 3,
    title: 'Alan River',
    userCount: 150
  }
]
